import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { SeguridadService } from "../service/seguridad.service";

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
  constructor(private seguridadService: SeguridadService) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // add authorization header with jwt token if available
    let token;
    token = this.seguridadService.getToken();

    if (request.url.includes('gis.bosques.gob.pe')) {
      return next.handle(request);
    }

    // if skip = true, not clone with token
    if (!request.headers.get('skip')) {
      if (token && token !== '') {
        request = request.clone({
          setHeaders: {
            Authorization: `Bearer ${token}`
          }
        });
      }
    }
    return next.handle(request);
  }
}